import { buildGoogleAuthUrl } from '../../auth/pkce';

export function GoogleButton({ label }: { label: string }) {
  return (
    <button
      type="button"
      onClick={async () => {
        window.location.href = await buildGoogleAuthUrl();
      }}
      className="flex w-full items-center justify-center gap-2 rounded-md border border-stone-300 bg-white px-4 py-2.5 font-medium text-stone-700 hover:bg-stone-50"
    >
      <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
        <path
          fill="#4285F4"
          d="M23.5 12.27c0-.79-.07-1.54-.2-2.27H12v4.51h6.46a5.52 5.52 0 0 1-2.4 3.62v3h3.88c2.27-2.09 3.56-5.17 3.56-8.86z"
        />
        <path
          fill="#34A853"
          d="M12 24c3.24 0 5.96-1.07 7.94-2.91l-3.88-3c-1.07.72-2.45 1.15-4.06 1.15-3.12 0-5.77-2.1-6.71-4.94H1.28v3.09A12 12 0 0 0 12 24z"
        />
        <path
          fill="#FBBC05"
          d="M5.29 14.3a7.2 7.2 0 0 1 0-4.6V6.61H1.28a12 12 0 0 0 0 10.78l4.01-3.09z"
        />
        <path
          fill="#EA4335"
          d="M12 4.76c1.76 0 3.34.6 4.58 1.79l3.44-3.44A11.97 11.97 0 0 0 12 0 12 12 0 0 0 1.28 6.61l4.01 3.09C6.23 6.86 8.88 4.76 12 4.76z"
        />
      </svg>
      {label}
    </button>
  );
}

export function AuthDivider() {
  return (
    <div className="my-4 flex items-center gap-3 text-xs uppercase tracking-wide text-stone-500">
      <div className="h-px flex-1 bg-stone-200" />
      or
      <div className="h-px flex-1 bg-stone-200" />
    </div>
  );
}
